function requireRegister($, routeClass, componentFunction){
    $(document).ready(function(){
        if($('body').is(routeClass)){
            componentFunction();
        }
    });
}
module.exports = requireRegister;
